export const phoneValidationRegex = /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/;

export const passwordValidationRegex =
  /^(?!.*(.)\1{2})(?=.{8,})((?=.*\d)(?=.*[a-z])(?=.*[A-Z])|(?=.*\d)(?=.*[a-zA-Z])(?=.*[\W_])|(?=.*[a-z])(?=.*[A-Z])(?=.*[\W_]))/;

export const cardValidationRegex = /^(\d{3})[-]?(\d{4})[-]?(\d{3})[-]?(\d{3})$/;

export const postalCodeValidationRegex = /^[a-zA-Z]\d[a-zA-Z]( )?\d[a-zA-Z]\d$/;

export const ProvinceValidation = /^(?!default\b)\b\w+/;

export const mfaCodeValidationRegex = /^\d{6}$/;

export const nameValidationRegex = /^[\w\s\-.à-öÀ-Öø-ÿØ-Ÿ]*$/;
